import React from "react";

import { ExperimentProvider } from "../experiments/";

type AnalyticsProviderProps = {
  children: React.ReactNode;
};

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  return <ExperimentProvider>{children}</ExperimentProvider>;
};
